import { Component } from '@angular/core';
import { Paragraph } from '@app/shared/components/paragraph/paragraph.component';

@Component({
  selector: 'app-developers',
  templateUrl: './developers.component.html',
  styleUrls: ['./developers.component.scss'],
  standalone: false,
})
export class DevelopersComponent {
  apiForTradersP: Paragraph = {
    header: 'developers.apiForTraders.header',
    standalone: true,
    content: 'developers.apiForTraders.content',
  };
  apiForBanksP: Paragraph = {
    header: 'developers.apiForBanks.header',
    standalone: true,
    content: 'developers.apiForBanks.content',
  };

  tradingBotsP: Paragraph = {
    header: 'developers.tradingBots.header',
    content: 'developers.tradingBots.content',
  };

  bitForMerchP: Paragraph = {
    header: 'developers.bitForMerch.header',
    content: 'developers.bitForMerch.content',
  };

  bitAtmP: Paragraph = {
    header: 'developers.bitAtm.header',
    content: 'developers.bitAtm.content',
  };

  apiIntegrationP: Paragraph = {
    content: 'developers.apiIntegration.content',
  };

  xchangeLibraryP: Paragraph = {
    content: 'developers.xchangeLibrary.content',
  };
}
